export default __webpack_public_path__ + "static/media/savedSearchIconV2.3fdbfccb.svg";